<template>
    <div class="page-index">
        <div class="hd">
            <div class="bg"></div>
        </div>
        <div class="bd">
            <div class="box">
                <div class="box-hd">
                    <div class="box-hd-label">订单总额</div>
                    <div class="box-hd-value">{{ totalFee }}元</div>
                </div>
                <div class="box-bd">
                    <div class="box-item">
                        <div class="box-bd-label">科室</div>
                        <div class="box-bd-value">{{ deptName }}</div>
                    </div>
                    <div class="box-item">
                        <div class="box-bd-label">病人姓名</div>
                        <div class="box-bd-value">{{ name }}</div>
                    </div>
                    <div class="box-item">
                        <div class="box-bd-label">支付类型</div>
                        <div class="box-bd-value">{{ payType }}</div>
                    </div>
                </div>
            </div>
            <div class="bd-append">
                <i class="bd-append-icon"></i>
                <div class="bd-append-text">医保退号</div>
            </div>
        </div>
        <div class="ft">
            <van-button type="primary" round block @click="doPay()">退号</van-button>
        </div>
    </div>
</template>

<script>

    import {getQueryString} from "../../utils/common";
    import {getOrderInfo, token} from "../../api/Api";
    import {Toast} from "vant";
    import Constant from "../../utils/Constant";

    export default {
        name: 'PageIndex',
        data() {
            return {
                openId: '',
                totalFee: '',
                deptName: '',
                name: '',
                payType: '',
                medOrgOrd: '',
                idNo: '',
            }
        },
        methods: {
            doPay() {
                console.log("进行支付授权")
                console.log("medOrgOrd", this.medOrgOrd)
                window.location.href = "https://card.wecity.qq.com/oauth/code?authType=2&isDepart=2" +
                    "&appid=wxbbbf21ec24a1b219&cityCode=654000&channel=AAF6rdbKBBhRyhHE9tQ3QdDs" +
                    "&orgChnlCrtfCodg=BqK1kMStlhVDgN2uHf4EsLK/F2LjZPYJ81nK2eYQqxsx1MunG//RTCcmH7CftmAe&orgCodg=H65400200247&bizType=04107&orgAppId=1HEMUSP0101P75430B0A000051FC0B7D" +
                    "&redirectUrl=https%3A%2F%2Fkt.tgzzykj.cn%2Fyy%2Fsdsp%2Fmipp%2Fauth%2FauthReturnCallBack/" + this.medOrgOrd + "/1";
            }
        },
        mounted: function () {
            this.$nextTick(async function () {
                window.document.title = "医保退号";
                Toast.loading({
                    message: '查询中...', duration: 0
                });

                this.medOrgOrd = getQueryString("medOrgOrd")
                this.openId = getQueryString("openId")
                console.log("openId", this.openId)
                this.$store.commit('setOpenId', this.openId)
                let res = await token({openId: this.openId, termNo: Constant.TermInfo.termNo, termType: Constant.TermInfo.termType, resourceType: '3'})
                if (res.status !== 200) {
                    console.log('get token 500')
                    throw new Error('系统异常，请稍后再试');
                }
                this.$store.commit('saveToken', res.data);

                this.medOrgOrd = getQueryString("medOrgOrd")
                let p = {
                    medOrgOrd: this.medOrgOrd,
                }
                let ret = await getOrderInfo(p);
                Toast.clear();
                if (ret.status !== 200) {
                    Toast.fail("查询订单信息失败！")
                    return;
                }
                this.totalFee = ret.data.totalFee
                this.deptName = ret.data.deptName
                this.name = ret.data.name
                this.payType = ret.data.payType
                this.idNo = ret.data.idNo
            })
        }
    }
</script>

<style scoped>
    @import '../../assets/index.css';
    @import '../../assets/actionsheet.css';

    .van-button--primary {
        color: #fff;
        background-color: #1989fa;
        border: 1px solid #1989fa;
    }
</style>
